export enum PlanDetailsScreenEnums {
  HEADING = 'Thank You',
  SUBHEADING = 'Mauris neque nisi, faucibus non elementum in, convallis et eros. Sed pretium sem libero, vel pellentesque',
  ICON_COLOR = 'white',
  BUTTON_LABEL = 'Subscribe',
  DESCRIPTION = "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
}
